import { useMutation } from '@tanstack/react-query';

import { uploadAgentChatFile } from '@/services/agents/files';

interface UploadAgentChatFileVariables {
  orgId: string;
  agentId: string;
  file: File;
}

export function useUploadAgentChatFile() {
  return useMutation({
    mutationFn: ({ orgId, agentId, file }: UploadAgentChatFileVariables) =>
      uploadAgentChatFile(orgId, agentId, file),
  });
}
